import SourceFlowText from "@sourceflow-uk/sourceflowtext"
import {
    Container,
    Row,
    Col,
} from "reactstrap";
import styles from './styles.module.scss';
import Link from 'next/link';

export default function SimpleTwoColumns({
    global,
    pathPrefix,
    customClass = "",
    content1,
    content2,
    colorCode,
    bottomBannerCTA = false,
    buttomBannerCTALINK,
    buttomBannerCTATitle
}) {

    return (
        <>
            <section className={`${styles.root} ${customClass}`}>
                <Container>
                    <Row className="shadow p-3 p-md-5 rounded-3 overflow-hidden m-0" style={{backgroundColor: colorCode}}>
                        {content1 ?
                            <Col lg={6} className={`${content2 ? "pe-lg-4" : "w-100"}`}>
                                <SourceFlowText global={global} path={`${pathPrefix}.content1`} type="html">
                                    {content1}
                                </SourceFlowText>
                                {bottomBannerCTA ?
                                    <Link
                                        href={buttomBannerCTALINK}
                                    >
                                        <a className="primaryBtn text-white text-decoration-none">
                                            <SourceFlowText global={global} path={`${pathPrefix}.buttomBannerCTATitle`}>{buttomBannerCTATitle}</SourceFlowText>
                                        </a>
                                    </Link>
                                    : ""}
                            </Col> : ""}
                        {content2 ?
                            <Col lg={6} className="ps-lg-4">
                                <SourceFlowText global={global} path={`${pathPrefix}.content2`} type="html">
                                    {content2}
                                </SourceFlowText>
                            </Col> : ""}
                    </Row>
                </Container>
            </section>
        </>
    )
}